import {
  GET_FILTERED_DATA,
  SET_FILTERED_DATA,
  SET_SELECTED_QUESTION,
  SET_DATA_DATES,
  SET_CATEGORY_DATA,
  SET_RAW_DATA,
  CLEAR_ALL,
  SET_QUESTIONS,
  SET_SUB_NAV,
  SET_NAVIGATION,
  SET_SELECTED_FILTERS,
  SET_DATA_ACNHOR,
} from "constants/actions";

const initialState = {
  filtered_data: [],
  question_structure: {},
  category_structure: {},
  selected: { id: 0 },
  dates: [],
  raw_data: [],
  sub: 1,
  filters: [],
  anchor: null,
  nav: null,
};

export default function Audit(state = initialState, action) {
  switch (action.type) {
    case SET_FILTERED_DATA:
      return {
        ...state,
        filtered_data: action.payload,
      };
    case SET_SELECTED_QUESTION:
      return {
        ...state,
        selected: action.payload,
      };
    case SET_DATA_DATES:
      return {
        ...state,
        dates: action.payload,
      };
    case SET_CATEGORY_DATA:
      return {
        ...state,
        category_structure: action.payload,
      };
    case SET_DATA_ACNHOR:
      return {
        ...state,
        anchor: action.payload,
      };
    case SET_RAW_DATA:
      return {
        ...state,
        raw_data: action.payload,
      };
    case SET_QUESTIONS:
      return {
        ...state,
        question_structure: action.payload,
      };
    case SET_SUB_NAV:
      return {
        ...state,
        sub: action.payload,
      };
    case SET_NAVIGATION:
      return {
        ...state,
        nav: action.payload,
      };
    case SET_SELECTED_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        filtered_data: [],
        question_structure: {},
        category_structure: {},
        dates: [],
        raw_data: [],
        sub: 1,
        selected: { id: 0 },
        nav: {},
        filters: [],
      };
    default:
      return state;
  }
}
